import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCFoxThief extends NPC {
    /**
     * @param {string} id
     */
    constructor(id) {
        super(id);

        this.collisionRadius = 34;
        this.collisionOffsetX = 6;
        this.collisionOffsetY = -34;
    }

    init() {
        super.init();

       // //console.log('FOX THIEF', this);

        this.addViewWithTexture(texture("char_fox_thief_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 1, new PIXI.Point(6, -8));
        this.animateIdle(0.7);
    }

    onViewAdded() {
        super.onViewAdded();

        this.status.x += 30;
    }
}